import { EntryAddressStatusDetails } from "@globals/openapi-models/model/entryAddressStatusDetails";
import { BiMapComponentAddressModel } from "./BiMapComponentAddressModel";
import { IMapAddressHolder } from "./IMapAddressHolder";

export class BiMapArea extends L.GeoJSON<any, GeoJSON.Geometry> implements IMapAddressHolder {
  address: EntryAddressStatusDetails | BiMapComponentAddressModel;
  type: "property";
  /**
   * Leaflet layer ID (created using L.stamp()) referring to the Polygon or pin marker containing this marker.
   * Note: a pin marker must have a defined radius in order to contain other markers.
   */
  parentShapeId?: number;
}
